/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
};

const defaultProps = {
    ...commonDefaultProps,
};

const Dot = (props) => {
    const classNames = [
        's-dot',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),

    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            <div className="s-dot__item" />
            <div className="s-dot__item" />
            <div className="s-dot__item" />
        </props.componentClass>
    );
};

Dot.propTypes = propTypes;

Dot.defaultProps = defaultProps;

export default Dot;
